import { Box, Divider, Typography } from '@mui/material';
import { CheckoutDataContext } from 'context/merchant-details.context';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import React, { useContext } from 'react';
import { formatNumberAsMoney } from 'util/contentParser/libs';
import { useStyles } from './CustomerInfo';

const OrderItems = ({ formData, tipAmount }: any) => {
  const { checkoutData, orderData } = useContext(CheckoutDataContext);
  const currency = checkoutData?.merchant.currency || 'EUR';
  const classes = useStyles();
  return (
    <Box>
      <Box>
        <div className="flex flex-between space-between w-60 mobile-w-full mb-6 m-w-90">
          <LocalMallOutlinedIcon />
          <Typography
            className={`${classes.title} border-right m-h5-height m-w-70`}
            variant="h5"
          >
            <strong className="font-xlarge">Order Summary &nbsp;</strong>
          </Typography>
          <span className="m-w-20">{orderData?.orderItems?.length} Items</span>
        </div>
        <Divider className="mt-10" />
      </Box>
      <Box>
        {orderData?.orderItems?.map((item: any) => (
          <Box key={item.name}>
            <div className="mt-20 mb-20 flex flex-between">
              {/* product image or logo */}
              <div className="flex flex-col">
                <span className="mt-10 extra-little-bold">{item.name}</span>
                <span className="mt-10">Quantity: {item.quantity}</span>
              </div>
              <div className="flex flex-col">
                <span className="mt-10">
                  {formatNumberAsMoney(item.unitPrice, currency)}
                </span>
              </div>
            </div>
          </Box>
        ))}
      </Box>
      <Divider />
      <Box>
        <div className="mt-15 flex order-summary-total-div">
          <span className="extra-little-bold">Sub-Total</span>
          <span>{formatNumberAsMoney(checkoutData?.merchant.subTotal, currency)}</span>
        </div>
        {!checkoutData?.merchant.hideTax && (
          <div className="mt-5 flex order-summary-total-div">
            <span className="extra-little-bold">Tax</span>
            <span>{formatNumberAsMoney(checkoutData?.merchant.taxAmount, currency)}</span>
          </div>
        )}
        {formData && formData.tipAmount ? (
          <div className="mt-5 flex order-summary-total-div">
            <span className="extra-little-bold">Tip</span>
            <span>{formatNumberAsMoney(formData.tipAmount, currency)}</span>
          </div>
        ) : null}
        {tipAmount ? (
          <div className="mt-5 flex order-summary-total-div">
            <span className="extra-little-bold">Tip</span>
            <span>{formatNumberAsMoney(tipAmount, currency)}</span>
          </div>
        ) : null}
        <Divider />

        <div className="mt-15 flex order-summary-total-div little-bold">
          <span>Total</span>
          <span>
            {formatNumberAsMoney(
              Number(checkoutData?.merchant.subTotal)
                + Number(checkoutData?.merchant?.taxAmount)
                + (formData ? Number(formData.tipAmount) : 0)
                + (tipAmount ? Number(tipAmount) : 0),
              currency
            )}
          </span>
        </div>
      </Box>
    </Box>
  );
};

export default OrderItems;
